module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 133
// module chunks = 0